import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { readDeskHandoffFromSearch } from "./deskHandoff";
import { authenticate, readSession, writeSession } from "./session";

const AuthContext = createContext(null);

function bootstrapSession() {
  const handoff = readDeskHandoffFromSearch(window.location.search);
  if (handoff) {
    writeSession(handoff);
    return handoff;
  }
  return readSession();
}

function applyDeskHandoff(search) {
  const handoff = readDeskHandoffFromSearch(search);
  if (!handoff) return null;
  writeSession(handoff);
  return handoff;
}

export function AuthProvider({ children }) {
  const [session, setSession] = useState(() => bootstrapSession());

  useEffect(() => {
    function onHandoff() {
      const next = applyDeskHandoff(window.location.search);
      if (next) setSession(next);
    }
    onHandoff();
    window.addEventListener("popstate", onHandoff);
    return () => window.removeEventListener("popstate", onHandoff);
  }, []);

  const value = useMemo(
    () => ({
      session,
      role: session?.role || null,
      isAuthenticated: Boolean(session),
      login(input) {
        const result = authenticate(input);
        if (result.ok) setSession(result.session);
        return result;
      },
      logout() {
        writeSession(null);
        setSession(null);
      },
    }),
    [session]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useJourneyAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useJourneyAuth needs AuthProvider");
  return ctx;
}
